var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Container = PIXI.Container;
import { Power2, TweenLite } from "gsap";
import { skip, take } from "rxjs/operators";
import { utilLoader } from "../utils/loader/utilLoader";
import { utilTick } from "../utils/utilTick";
// All buildings should animate in 2 seconds of time.
// We delay the animation to stagger it, making more pleasing to the eye.
var animationFrameDelayPool = new Array(10).fill(1).map(function () { return Math.random() * 30; });
var LoadingBuildingGraphicIso = /** @class */ (function (_super) {
    __extends(LoadingBuildingGraphicIso, _super);
    function LoadingBuildingGraphicIso(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.onRemoved = function () {
            _this.off("removed", _this.onRemoved);
            if (_this.bundleLoadedSub$) {
                _this.bundleLoadedSub$.unsubscribe();
            }
            if (_this.animStartSub$) {
                _this.animStartSub$.unsubscribe();
            }
            _this.removeChildren();
        };
        _this.onBundleLoaded = function (id) {
            if (id !== _this.options.bundleId) {
                return;
            }
            var building = _this.options.building;
            var numFrameDelay = animationFrameDelayPool[building.balancing.id % animationFrameDelayPool.length];
            _this.animStartSub$ = utilTick.frame$
                .pipe(skip(numFrameDelay), take(1))
                .subscribe(_this.replaceWithActualGraphic);
        };
        _this.replaceWithActualGraphic = function () {
            var _a = _this.options, building = _a.building, getGraphicsIso = _a.getGraphicsIso;
            var display = getGraphicsIso(building);
            _this.bundleLoadedSub$.unsubscribe();
            _this.animStartSub$.unsubscribe();
            if (display != undefined) {
                var loadingGraphic = _this.getChildAt(0);
                _this.addChildAt(display, 0);
                _this.animateFadeOutLoading(loadingGraphic, display);
            }
        };
        _this.animateFadeOutLoading = function (loading, building) {
            TweenLite.to(loading, LoadingBuildingGraphicIso.ANIM_TIME, {
                alpha: 0,
                ease: Power2.easeInOut,
                onComplete: function () { return _this.removeChild(loading); },
            }).play();
        };
        _this.addLoadingGraphic = function () {
            var _a = _this.options, building = _a.building, getLoadingIso = _a.getLoadingIso;
            var display = getLoadingIso(building);
            if (display != undefined) {
                _this.addChild(display);
            }
        };
        _this.addLoadingGraphic();
        _this.bundleLoadedSub$ = utilLoader.bundleLoaded$.subscribe(_this.onBundleLoaded);
        _this.on("removed", _this.onRemoved);
        return _this;
    }
    LoadingBuildingGraphicIso.ANIM_TIME = 0.2;
    return LoadingBuildingGraphicIso;
}(Container));
export { LoadingBuildingGraphicIso };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/LoadingBuildingGraphicIso.ts
// module id = 866
// module chunks = 3